import { jsx as _jsx } from "react/jsx-runtime";
// AlertContext.tsx
import { createContext, useContext, useEffect, useRef, useState } from 'react';
import * as signalR from '@microsoft/signalr';
const AlertContext = createContext(undefined);
export const AlertProvider = ({ children }) => {
    const [alerts, setAlerts] = useState();
    const [totalAlerts, setTotalAlerts] = useState(0);
    const [showTooltip, setShowTooltip] = useState(false);
    const prevIncidentIdsRef = useRef(new Set());
    const apiUrl = process.env.REACT_APP_API_URL;
    const baseUrl = apiUrl?.replace(/\/api\/?$/, '');
    useEffect(() => {
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(`${baseUrl}/notificationHub`)
            .withAutomaticReconnect()
            .build();
        connection.start().catch(() => { });
        connection.on('ReceiveNotification', (message) => {
            const currentCriticalAlerts = message?.criticalIncidentAlert || [];
            const currentIds = new Set(currentCriticalAlerts.map((alert) => alert.incidentId));
            const previousIds = prevIncidentIdsRef.current;
            const hasNewId = [...currentIds].some((id) => !previousIds.has(id));
            if (hasNewId) {
                setShowTooltip(true);
            }
            prevIncidentIdsRef.current = currentIds;
            setAlerts(message);
            setTotalAlerts(message?.allIncidentAlert?.length || 0);
        });
        return () => {
            connection.stop();
        };
    }, []);
    return (_jsx(AlertContext.Provider, { value: { alerts, totalAlerts, showTooltip, setShowTooltip, setAlerts }, children: children }));
};
export const useAlertContext = () => {
    const context = useContext(AlertContext);
    if (!context) {
        throw new Error('useAlertContext must be used within an AlertProvider');
    }
    return context;
};
